<template>
  <div class="mapbox">
    <!-- 图片滚动视图 -->
    <!-- <template v-if="!showChart"> -->
    <div class="image">
      <div class="closebtn" @click="$emit('goBack')">关闭 ×</div>

      <!-- <div style="width: 36px; height: 36px"></div> -->
      <!-- <button class="to-chart" @click="showChart = !showChart">&#8592;</button> -->

      <div class="scroll-wrapper">
        <!-- <div class="header">溯源图片</div> -->

        <div class="scroll-track" ref="track">
          <img v-for="(img, i) in images" :key="i" :src="img" class="scroll-item" />
        </div>
      </div>
    </div>

    <!-- <button class="to-chart" @click="showChart = !showChart">&#8594;</button> -->
    <!-- </template> -->

    <!-- 图表视图 -->
    <!-- <template v-else>
      <button class="to-photo" @click="showChart = !showChart">&#8592;</button>

      <div class="chart-area">
        <div class="header">图表数据</div>

  
      </div>

      <div style="width: 36px; height: 36px"></div>
    </template> -->
  </div>
</template>

<script>
export default {
  name: 'TraceDetail',

  data() {
    return {
      showChart: false,
      images: [require('@/assets/images/trace_process.png')]
    }
  },

  computed: {},

  methods: {
    // scrollUp() {
    //   this.$refs.track.scrollBy({ top: -220, behavior: 'smooth' })
    // },
    // scrollDown() {
    //   this.$refs.track.scrollBy({ top: 220, behavior: 'smooth' })
    // }
  }
}
</script>

<style scoped>
.mapbox {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 16px;
  gap: 12px;
}

.image {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.header {
  color: white;
  font-size: 28px;
  font-weight: 600;
  text-align: center;
}

.scroll-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  height: 100%;
  gap: 8px;
  overflow: hidden;
}

.scroll-track {
  display: flex;
  flex-direction: column;
  gap: 40px;
  overflow-y: auto;
  scrollbar-width: none;
  width: 100%;
  height: 100%;
  padding: 0 20px 30px;
}

.scroll-track::-webkit-scrollbar {
  display: none;
}

/* 图片样式 */
.scroll-item {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
  /* border: 1px solid #1a6b8a; */
}

.arrow {
  flex-shrink: 0;
  background: rgba(0, 180, 220, 0.15);
  border: 1px solid #00cfff;
  color: #00cfff;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 18px;
}

.to-chart,
.to-photo {
  flex-shrink: 0;
  align-self: center;
  background: rgba(0, 180, 220, 0.15);
  border: 1px solid #00cfff;
  color: #00cfff;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 20px;
}

.chart-area {
  flex: 1;
  height: 100%;
}

.closebtn {
  color: #83ffe1;
  text-align: right;
  margin: 20px 15px;
  cursor: pointer;
}
</style>
